import React from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import rocket from 'src/assets/json/rocket-launch.json'

export const YappyEsperaConfirmacion = () => {
  return (
    <div>
      <div className='text-center'>
        <Player
          autoplay
          loop
          src={rocket}
          style={{ height: '200px', width: '200px' }}
        >
          {/* <Controls visible={true} buttons={['play', 'repeat', 'frame', 'debug']} /> */}
        </Player>
        <br />
        <h5 className='fw-bold text-dark'>Confirma tu pedido en Yappy</h5>
        <p className='form-text'>Busca la notificación en <strong className='text-fedpa'> Yappy App </strong>
          o revisa <br /> la bandeja de pendientes en el<strong> app de tu banco</strong> </p>

        <h5
          className='btn btn-outline-primary'
          style={{
            fontWeight: 'normal',
            fontSize: '15px',
          }}
        >
          Tienes 5 minutos para aceptar el pedido <br /> desde tu celular
        </h5>
      </div>
    </div>
  )
}
